import Select from "./Select";
import { withErrorMessage } from "../withErrorMessage";

export const FieldSelect = withErrorMessage(Select);

export default FieldSelect;
